import React from 'react'
import { Typewriter } from 'react-simple-typewriter';



const Hero = ({ darkMode }) => {


  return (
    <div className='mb-5'>
        <div className='my-hight'></div>
        <div className={`container-lg  hero-section }`}>
            <div className="row mt-5 align-items-center justify-content-center mb-5 ">
                <div className='col-10 text-center  '>
                    <img src="img/me.jpg" className=' rounded-circle hero-img-me mt-4 mx-4' alt="My Pic" />
                    <h1 className=' p-4 pb-0 responsive-HXXtext ' style={{ letterSpacing: ".15em",  fontWeight: "bold", color: "#c2b41e", textShadow: "rgb(124 119 119 / 70%) 3px 3px 15px, rgba(255, 255, 255, 0.3) 0px 0px 5px" }}>
                    <Typewriter
                        words={["Hi, My Name is Ahmed, I'm MTE Engineer!"]}
                        loop={1}
                        cursor
                        cursorStyle="|"
                        typeSpeed={70}
                        deleteSpeed={50}
                        delaySpeed={1000}
                    />
                    </h1>
                    <p className='hero-dTitle px-4 responsive-Htext' style={{}}><br/>I create innovative solutions for a seamless and user-friendly experience.</p>
                </div>
                
            </div>
            <div className="justify-content-center d-flex mb-5">
            
            <img src={` ${darkMode ? "img/HarrowWh.png" : "img/HarrowBL.png"}`} className='img-fluid' alt="" />

            </div>
        </div>
    </div>
  )
};

export default Hero